const getDefaultsFromPostinstall = () => ({
  "config": {
    "apiKey": "AIzaSyDWbSx2YYQXNmFqvJ8YkSqyk-NuSMwQjZQ",
    "appId": "1:895798999772:web:a1827f05cfef27abf05219",
    "authDomain": "rooftop-stg.firebaseapp.com",
    "databaseURL": "https://rooftop-stg-default-rtdb.firebaseio.com",
    "messagingSenderId": "895798999772",
    "projectId": "rooftop-stg",
    "storageBucket": "rooftop-stg.appspot.com"
  },
  "emulatorHosts": {}
});
export { getDefaultsFromPostinstall };